<template>
    <div class="affirmation" :data-processing="processing">
       <!-- {{instance}} -->

        <!-- * IF/THEN (ARRAY) -->
        <div v-if="type === 'ifthen'" class="affirmation__response affirmation__response--ifthen v--25">
            <div v-if="selectedResponse.then" 
                class="affirmation__response__then"
                :class="selectedResponse.is_correct" 
                >
                <h3 v-if="instance.display_check_field_answer === 'yes'" v-text="answer" class="type--h3--default"></h3>
                <div class="type--content-styles type--content-margins type--content-links" v-html="selectedResponse.then"></div>
            </div>
            <div v-if="selectedResponse.image" class="affirmation__response__image r r--justify-center r--halign-center">
                <PictureDynamic :id="selectedResponse.image" :size="imageSize" alt="Affirmation Image" :siloData="siloData"/>
            </div>
        </div>

        <!-- * EMPTY --> 
        <div v-if="type === 'empty'" class="affirmation__response affirmation__response--empty v--25">
            <div v-if="isEmpty" class="affirmation__response__container affirmation__response__container--empty">
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links" v-html="instance.if"></div>
                <div class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_if" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
            <div v-if="!isEmpty" class="affirmation__response__container affirmation__response__container--not-empty">
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.else"></div>
                <div class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_else" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
        </div>

        <!-- * IF/ELSE -->
        <div v-if="type === 'ifelse'" class="affirmation__response affirmation__response--ifelse v--25">
            <div v-show="isAnswerThis" class="affirmation__response__container affirmation__response__container--is">
                <Kudo v-if="instance.if_correct === 'yes'" :instance="instance" :active="isAnswerThis" />
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.if"></div>
                <div v-if="instance.image_if" class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_if" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
            <div v-show="!isAnswerThis" class="affirmation__response__container affirmation__response__container--is-not">
                <Kudo v-if="instance.else_correct === 'yes'" :instance="instance" :active="!isAnswerThis" />
                <div class="affirmation__response__then type--content-styles type--content-margins type--content-links"
                    v-html="instance.else"></div>
                <div v-if="instance.image_else" class="affirmation__response__image r r--justify-center r--halign-center">
                    <Picture :id="instance.image_else" :size="imageSize" alt="Affirmation Image" :siloData="siloData" />
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import PictureDynamic from "@c/PictureDynamic.vue";
import Picture from "@c/Picture.vue";
import Kudo from "@c/panels/Kudo.vue";
    export default {
        components: {
            PictureDynamic,
            Picture,
            Kudo,
        },
        data() {
            return {
                imageSize: "full",
                processing: this.instance.type !== "empty" ? true : false,
                type: this.instance.type === undefined ? "ifthen" : this.instance.type,
            }
        },
        computed: {
            answer() {
                return this.siloData.user.modules[this.instance.check_field] ? this.siloData.user.modules[this.instance.check_field] : null;
            },
            selectedResponse() {
                if (this.instance.type !== "empty") {
                    this.processing = true;
                }
                
                let returned = {
                    then: "",
                    image: null,
                    is_correct: "",
                };
                // Look through all the responses
                this.instance.responses.forEach(response => {
                    // If your response is your answer
                    if (response.if === this.answer) {
                        // return the then
                        returned.then = response.then;
                        // return the image
                        returned.image = response.image;
                        // return truefalse
                        returned.is_correct = response.is_correct;

                        this.processing = false;
                    }
                });
                return returned;
            },
            isEmpty() {
                return this.answer.length > 0 ? false : true;
            },
            isAnswerThis() {

                // If this is an array, compare it against the first item in the array
                if (Array.isArray(this.answer)) {
                    return this.answer[0] === this.instance.if_equals_text ? true : false;
                // Otherwise, just compare it against the string
                } else {
                    return this.answer === this.instance.if_equals_text ? true : false;
                }
            },
        },
        props: {
            siloData: Object,
            instance: Object,
            active: Boolean,
        },
        watch: {
            siloData: {
                handler() {
                    // This doesn't apply to empty type
                    if (this.instance.type === "empty") return;
                    this.processing = true;
                },
                immediate: true,
            },
        }
    }
</script>

<style lang="scss">
@import "@s/_mixins.scss";
@import "@s/_vars.scss";

$icon_incorrect: '<svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26"><g fill="none"><path fill="#E87C6E" d="M13.604 0c-7.15 0-13 5.85-13 13s5.85 13 13 13 13-5.85 13-13-5.85-13-13-13Z"/><path fill="#FAF7F2" fill-rule="evenodd" d="M16.722 8.323a1.103 1.103 0 1 1 1.56 1.559L15.162 13l3.118 3.118a1.103 1.103 0 1 1-1.559 1.56l-3.117-3.12-3.118 3.118c-.4.4-1.03.428-1.463.086l-.096-.086a1.102 1.102 0 0 1 0-1.559L12.044 13 8.927 9.882a1.103 1.103 0 1 1 1.559-1.56l3.118 3.12Z"/></g></svg>';
$icon_correct: '<svg width="26" height="26" xmlns="http://www.w3.org/2000/svg"><path d="M13 0C5.85 0 0 5.85 0 13s5.85 13 13 13 13-5.85 13-13S20.15 0 13 0Zm7.683 9.832-8.077 7.873c-.214.21-.472.295-.773.295a.952.952 0 0 1-.73-.295L7.323 14a1.004 1.004 0 0 1 0-1.474c.429-.42 1.116-.42 1.503 0l3.007 2.948 7.303-7.158c.43-.421 1.117-.421 1.504 0 .473.42.473 1.095.043 1.516Z" fill="#7dc368" fill-rule="nonzero"/></svg>';
.affirmation {
    [data-processing="true"] {
        .affirmation__response__then {
            opacity: 0;
        }
        .affirmation__response__image {
            opacity: 0;
        }
    }
}
.affirmation__response__then {
    &.answer {
        padding-left: rem(39px);
        &:before {
            content: "";
            display: block;
            width: rem(26px);
            height: rem(26px);
            position: absolute;
            left: 0;
            top: 1px;
            background-repeat: no-repeat;
        }
    }
    &.answer--correct {
        &:before {
            background-image: svg-url($icon_correct);
        }
    }
    &.answer--incorrect {
        &:before {
            background-image: svg-url($icon_incorrect);
        }
    }
}
.affirmation {
    h3 {
    margin-bottom: 1px;
}
}
</style>